import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { subAccountViewSelector } from '../../features/subaccounts/subaccountSlice';
import { enableMapToolbar, disableMapToolbar } from '../../features/map/mapSlice';
import { setMapControl } from '../../features/map/mapSlice';

import SubAccountZones from './SubAccountZones';
import SubAccountMarkers from './SubAccountMarkers';
import SubAccountVehiclesList from './SubAccountVehiclesList';
import SubAccountReports from './SubAccountReports';

const SubAccountMainView = () => {
    const subAccountView = useSelector(subAccountViewSelector);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(disableMapToolbar());
        return () => {
            dispatch(enableMapToolbar());
            dispatch(setMapControl('asset'));
        }
    }, [dispatch]);



    const viewSelect = () => {
        switch (subAccountView) {
            case 'main':
                return null;
            case 'vehicleSelect':
                return <SubAccountVehiclesList />;
            case 'zoneSelect':
                return <SubAccountZones />;
            case 'markerSelect':
                return <SubAccountMarkers />;
            case 'reportSelect':
                return <SubAccountReports />;
            default:
                return null;
        }
    }

    return (
        <div>{viewSelect()}</div>
    )
}

export default SubAccountMainView;